export enum ContentTypeType {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
}

export const onClickPageRevert = ({
	push,
	contentType,
	spaceKey,
	contentId,
}: {
	push: (url: string, forceReload?: boolean | undefined) => void;
	contentType?: string;
	spaceKey: string | null;
	contentId?: string;
}) => {
	if (contentType && contentId) {
		const isBlogPost = contentType === 'blogpost';
		const url = isBlogPost
			? `${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`
			: `${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`;

		push(url);
	}
};
